module.exports = __webpack_public_path__ + "img/permisson-comparison1.65c4f650.jpg";